export const en_genders = [
  { value: 1, Name: 'Male' },
  { value: 2, Name: 'Female' },
];
export const ar_genders = [
  { value: 1, Name: 'ذكر', },
  { value: 2, Name: 'انثى', },

];
